<template>
  <div class="day-report-line-list">
    <div v-if="!current_active" class="d-flex justify-center mb-2">
      <v-btn
        variant="text"
        size="small"
        color="primary-darken-1"
        class="mr-2"
        @click="showAll"
      >
        <v-icon start size="small">mdi-chevron-down</v-icon>
        Alles uitklappen
      </v-btn>
      <v-btn
        variant="text"
        size="small"
        color="primary-darken-1"
        @click="closeAll"
      >
        <v-icon start size="small">mdi-chevron-up</v-icon>
        Alles inklappen
      </v-btn>
    </div>
    <div class="d-flex justify-end mb-2">
      <v-switch
        v-model="showImportantOnly"
        color="red"
        label="Alleen belangrijk"
        hide-details
        density="compact"
        inset
      />
    </div>
    <v-expansion-panels v-model="panel" multiple class="day-report-line-panels">
      <DayReportLineListHour
        v-for="(hour, index) in grouped_day_report_lines"
        :key="index"
        :index="index"
        :hour="hour"
      />
    </v-expansion-panels>
  </div>
</template>

<script>
import DayReportLineListHour from "./DayReportLineListHour.vue";
import { groupDayReportLinesByHour } from "@/utils/dayReportLineGrouping";

export default {
  name: "DayReportLineList",
  components: { DayReportLineListHour },
  props: ["day_report_lines", "current_active"],
  data: () => ({
    item: {},
    editItem: false,
    backupItem: {},
    panel_value: [],
    showImportantOnly: false,
  }),
  computed: {
    grouped_day_report_lines() {
      // Grouping/sorting is done on the server's Amsterdam `date`/`time` strings
      // (see the util), so it never depends on the device timezone.
      return groupDayReportLinesByHour(this.day_report_lines, {
        importantOnly: this.showImportantOnly,
      });
    },
    last_item() {
      return this.number_of_groups - 1;
    },
    number_of_groups() {
      return Object.keys(this.grouped_day_report_lines).length;
    },
    panel: {
      get: function () {
        if (this.current_active) {
          return Array.from(Array(this.number_of_groups).keys());
        }
        return this.panel_value;
      },
      set: function (value) {
        this.panel_value = value;
      },
    },
  },
  mounted: function () {
    this.current_active ? this.showAll() : this.closeAll();
  },
  methods: {
    showAll() {
      this.panel = Array.from(Array(this.number_of_groups).keys());
    },
    closeAll() {
      this.panel = [this.last_item];
    },
  },
};
</script>

<style scoped>
.day-report-line-list {
  margin-bottom: 16px;
}

.day-report-line-panels {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

::deep(.v-expansion-panel) {
  background-color: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
}

::deep(.v-expansion-panel:last-child) {
  border-bottom: none !important;
}

::deep(.v-expansion-panel-title) {
  padding: 12px 16px;
  min-height: 48px;
}

::deep(.v-expansion-panel-title__overlay) {
  background-color: rgba(0, 0, 0, 0.02);
}

::deep(.v-expansion-panel-text__wrapper) {
  padding: 0 !important;
}
</style>
